import React from 'react';
import {PageTemplate} from '../molecules';
import {PageHeader, LegalSection} from '../organisms';

const LegalPage = () => {
  return (
    <PageTemplate
      pageHeader={<PageHeader reverse={true} />}
    >
      <LegalSection />
    </PageTemplate>
  );
};

export default LegalPage;


// WEBPACK FOOTER //
// ./src/app/components/pages/LegalPage.js